// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventPlayerGameLogGetBody = {
  playerId: string;
  teamId: string;
  seasonId: string;
  timeZone: string;
};

export type typeEventPlayerGameLogGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    playerId: string;
    teamId: string;
    seasonId: string;
    sportKey: "football" | "basketball" | "baseball" | "hockey" | null;
    hasTeamGames: boolean;
    hasGames: boolean;
    games: {
      eventId: string;
      dateLabel: string;
      opponentLabel: string;
      resultCode: "W" | "L" | "T" | null;
      scoreLabel: string | null;
    }[];
    tables: {
      key: string;
      label: string;
      columns: { key: string; label: string }[];
      rows: { eventId: string; cells: { key: string; display: string }[] }[];
    }[];
  };
};

export type typeEventPlayerGameLogGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlayerGameLogGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlayerGameLogGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventPlayerGameLogGetBody = {
  type: "object",
  properties: {
    playerId: { type: "string", maxLength: 3000, minLength: 1 },
    teamId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonId: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["playerId", "teamId", "seasonId", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventPlayerGameLogGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventPlayerGameLogGetBody);
  }

  return async function postEventPlayerGameLogGet(
    payload: typeEventPlayerGameLogGetBody,
  ): Promise<
    typeEventPlayerGameLogGetOutput200 | typeEventPlayerGameLogGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventPlayerGameLogGet" failed before calling the network. #cb0268b0add0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cb0268b0add0" },
        },
        data: null,
      } as typeEventPlayerGameLogGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/player-game-log-get`,
      httpMethod: "POST",
      options,
    })) as
      typeEventPlayerGameLogGetOutput200 | typeEventPlayerGameLogGetOutput400;
  };
}
